import React from 'react';
import "../Figure.css"


export function Figure13() {
  return (
    <div>
        <table class="equal-width-table">
          <thead>
            <tr>
              <th></th>
              <th> Dilution</th>
              <th> Initial count </th>
              <th> Mucus </th>
              <th> % </th>
            </tr>
          </thead>
          <tbody>
          <tr>
              <th> Control </th>
              <td> 1:10 </td>
              <td> 704 </td>
              <td> 2 </td>
              <td> 0.28% </td>
            </tr>           
            <tr>
              <th>  </th>
              <td> 1:100 </td>
              <td> 78 </td>
              <td> 0 </td>
              <td> 0% </td>
            </tr> 
            <tr>
              <th>  </th>
              <td> </td>
              <td>  </td>
              <td>  </td>
              <td> </td>
            </tr>
            <tr>
              <th> D1D2 </th>
              <td> 1:1 </td>
              <td> 189 </td>
              <td> 16 </td>
              <td> 8.46% </td>
            </tr>           
            <tr>
              <th>  </th>
              <td> 1:10 </td>
              <td> 25 </td>
              <td> 1 </td>
              <td> 4% </td>
            </tr> 
            <tr>
              <th>  </th>
              <td> </td>
              <td>  </td>
              <td>  </td>
              <td> </td>
            </tr>
            <tr>
              <th> D2 </th>
              <td> 1:1 </td>
              <td> 140 </td>
              <td> 0 </td>
              <td> 0% </td>
            </tr>           
            <tr>
              <th>  </th>
              <td> 1:10 </td>
              <td> 9 </td>
              <td> 1 </td>
              <td> 11.1% </td>
            </tr> 
            <tr>
              <th>  </th>
              <td> </td>
              <td>  </td>
              <td>  </td>
              <td> </td>
            </tr>
          </tbody>
        </table>
    </div>
  );
}



export function Figure17() {
  return (
    <div>
        <table class="equal-width-table">
          <thead>
            <tr>
              <th> Sample 1 </th>
              <th> Sample 2 </th>
              <th> p-value </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td> D1D2 </td>
              <td> D1D2 uninduced </td>
              <td> 8.00325E-13 </td>
            </tr>             
            <tr>
              <td> D1D2 </td>
              <td> D1D2 permeable </td>
              <td> 1.56327E-06 </td>
            </tr>
            <tr>
              <td> D1D2 uninduced </td>
              <td> D1D2 permeable </td>
              <td> 3.87818E-11 </td>
            </tr> 
          </tbody>
        </table>
    </div>
  );
}
